'use no memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { Separator } from '@/components/ui/separator';
import { DeviceCatalogQueryProvider } from '@/features/form-factory';
import { DeviceQueryProvider } from '@/features/form-factory/context/DeviceQueryContext';
import { useDesktopOrMobileMediaQuery } from '@/hooks/useMediaQuery';
import { cn } from '@/lib/cn';
import GlobalHeaderPc from './_individual/individual/-components/GlobalHeader/GlobalHeaderPc';
import GlobalHeaderSp from './_individual/individual/-components/GlobalHeader/GlobalHeaderSp';
import { fetchIndividualDeviceCatalogById, useIndividualDeviceCatalogsForSelect } from './_individual/individual/device-catalog/-query/useDeviceCatalogsForSelect';
import { fetchIndividualDeviceById, useIndividualDevicesForSelect } from './_individual/individual/device/-query/useDevicesForSelect';
export const Route = createFileRoute('/_individual')({
  component: IndividualLayout
});
function IndividualLayout() {
  const {
    isDesktop
  } = useDesktopOrMobileMediaQuery();
  return <DeviceCatalogQueryProvider useDeviceCatalogsForSelect={useIndividualDeviceCatalogsForSelect} fetchDeviceCatalogById={fetchIndividualDeviceCatalogById}>
      <DeviceQueryProvider useDevicesForSelect={useIndividualDevicesForSelect} fetchDeviceById={fetchIndividualDeviceById}>
        {/* TODO: fixed inset-0 はビューポートに貼り付けることで html/body スクロールを回避している。
            根本対応として html, body, #root に overflow-hidden を設定し、h-dvh に置き換えることを検討する。 */}
        <VStack className="fixed inset-0 overflow-hidden bg-blue-50">
          {isDesktop ? <GlobalHeaderPc /> : <GlobalHeaderSp />}
          <Separator />
          <main className={cn('flex-1 min-h-0 overflow-auto')}>
            <Outlet />
          </main>
        </VStack>
      </DeviceQueryProvider>
    </DeviceCatalogQueryProvider>;
}